angular
  .module("contractTable.module", ["app.services"])
  .component("contractTable", {
    templateUrl: "ng/components/contractTable/contractTable.view.html",
    controllerAs: "ContractTableCtrl",
    bindings: {
      identifierAppCustomer: "=",
      home: "@",
      homeContractList: "<"
    },
    controller: function (
      $scope,
      HttpService,
      $rootScope,
      FileUploader,
      validationService,
      $searchUserService,
      $simulationService,
      $contractService,
      FactoryObj,
      $filter,
      $modalService,
      $timeout,
      $featureService,
      $configService,
      $digitalSignatureService,
      $download
    ) {
      $scope.ArfDigitalSign = $featureService.ArfDigitalSign();
      $scope.ArfPrintContractDetail = $featureService.ArfPrintContractDetail();

      $scope.navigator = "";

      /** this refererence depends from context */
      var self = this;

      self.$digitalSignatureService = $digitalSignatureService;
      self.validationService = validationService;

      self.searchUserService = $searchUserService;

      self.getListAppContractWorks = false;

      $rootScope.$on("refreshListAppContract", function (event, args) {
        console.log(
          "BROADCAST CALL - refreshListAppContract - self.getListAppContractWorks=" +
          self.getListAppContractWorks
        );
        if (!self.getListAppContractWorks) {
          self.getListAppContractWorks = true;
          getListAppContract(args.identifierAppCustomer);
        }
      });

      $rootScope.$on("refreshListAppTotalContract", function (event) {
        console.log(
          "BROADCAST CALL - refreshListAppContract - self.getListAppContractWorks=" +
          self.getListAppContractWorks
        );
        if (!self.getListAppContractWorks) {
          self.getListAppContractWorks = true;
          getListAppTotalContract();
        }
      });

      self.propMap = propMap;

      self.$onInit = function () {
        self.selectedContract = null;
        self.getContractStatusList();
        if (self.home == "true") {
          self.searchUserObj.contractList = self.homeContractList || [];
        }
      };

      self.$onChanges = function (changes) {
        self.searchUserObj.contractList = changes.homeContractList.currentValue;
      };

      self.goToContractDocumentation = function (contractItem) {
        if (self.home == "true") {
          FactoryObj.selectedContract = contractItem;
          //	FactoryObj.selectedContract.idContract = contractItem.idContract;
          $scope.navigator = "contract-docs";
        } else {
          FactoryObj.selectedContract = contractItem;
          // leasingConfiguration and searchUser controllers are listening and will change navigator.viewIndex to 1
          $scope.$emit("goToContractDocumentation", {});
        }
      };

      self.searchUserObj = {
        contractList: []
      };

      if ($configService.getUser().type == "VENDOR_AGENT") {
        self.filterAllContracts = {
          appContract: {
            limit: 4,
            offset: 0,
            pageIndex: 1,
            totalPages: 0,
            orderColumnName: "UPDATE_DATE",
            orderType: "DESC",
            pivaCustomer: null
          }
        };
      } else {
        self.filterAllContracts = {
          appContract: {
            limit: "4",
            offset: 0,
            pageIndex: 1,
            totalPages: 0,
            orderColumnName: "UPDATE_DATE",
            orderType: "DESC",
            identifierAppCustomer: null,
            identifierAppVendor: null
          }
        };
      }

      self.contractPrinted = false;
      /** Set true only if the search method ever returned */
      self.searchReturned = false;

      self.mapContractStatus = {};

      self.getContractStatusList = function () {
        HttpService.send(
          "/uni/typedomain/getDomainSet", {
          table: "APP_CONTRACT",
          column: "CONTRACT_STATUS"
        },
          false
        ).then(function (response) {
          self.contractStatusList = response.domainList;

          angular.forEach(self.contractStatusList, function (item) {
            switch (item.value) {
              case $rootScope.propMap["CONTRACT_STATUS_SPRINT_START"]:
              case $rootScope.propMap["CONTRACT_STATUS_SPRINT_END"]:
                // IN LAVORAZIONE ALBA
                self.mapContractStatus[
                  item.value
                ] = self.contractStatusList.find(function (el) {
                  return (
                    el.value == $rootScope.propMap["CONTRACT_STATUS_CREATED"]
                  );
                }).name;
                break;
              case $rootScope
                .propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE"]:
              case $rootScope
                .propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE_CHECKED"]:
              case $rootScope
                .propMap["CONTRACT_STATUS_CHOSEN_MANUAL_SIGNATURE"]:
                //DELIBERATO
                self.mapContractStatus[
                  item.value
                ] = self.contractStatusList.find(function (el) {
                  return (
                    el.value ==
                    $rootScope.propMap["CONTRACT_STATUS_DELIBERATED"]
                  );
                }).name;
                break;
              case $rootScope.propMap["CONTRACT_STATUS_CONTRACT_STIPULATED"]:
              case $rootScope
                .propMap["CONTRACT_STATUS_CONTRACT_STIPULATED_FINAL"]:
                //SIGNED
                self.mapContractStatus[
                  item.value
                ] = self.contractStatusList.find(function (el) {
                  return (
                    el.value ==
                    $rootScope.propMap[
                    "CONTRACT_STATUS_CONTRACT_STIPULATED_FINAL"
                    ]
                  );
                }).name;
                break;
              default:
                self.mapContractStatus[item.value] = item.name;
                break;
            }
          });
          console.log("self.contractStatusList: ", self.contractStatusList);
        });
      };

      //To retrieve all the contracts
      var getListAppContract = function (identifierAppCustomer) {
        if ($configService.getUser().type == "VENDOR_AGENT") {
          //called by broadcast
          if (identifierAppCustomer) {
            self.filterAllContracts.appContract.pivaCustomer = identifierAppCustomer;
          }

          $contractService
            .getAllContractsByFilter(self.filterAllContracts.appContract)
            .then(function (response) {
              console.log("identifierAppCustomer" + identifierAppCustomer);
              self.getListAppContractWorks = false;
              var contractList = response && response.allAppContractList;
              console.log("contractList: ", contractList);
              var totalCount = response && response.allAppContractListCount;
              console.log("contractList totalCount: ", totalCount);
              self.filterAllContracts.appContract.totalPages = getSTotalPages(
                totalCount
              );
              console.log(
                "filterAllContracts.appContract.totalPages: ",
                self.filterAllContracts.appContract.totalPages
              );
              self.searchUserObj.contractList = [];
              self.searchUserObj.contractList = addEmptyRow(contractList);
              console.log(
                "contractList LENGTH: ",
                self.searchUserObj.contractList.length
              );
            });
        } else {
          //called by broadcast
          if (identifierAppCustomer) {
            self.filterAllContracts.appContract.identifierAppCustomer = identifierAppCustomer;
            self.filterAllContracts.appContract.pivaCustomer = identifierAppCustomer;
            if ($rootScope.context == "portal-list/ara/") {
              //					self.filterAllContracts.appContract.identifierAppVendor = FactoryObj.selectedAppVendorUser.ndg;
              self.filterAllContracts.appContract.identifierAppVendor = $configService.getUser().identifier;
            } else {
              //	self.filterAllContracts.appContract.identifierAppVendor = $configService.getUser().identifier;
              self.filterAllContracts.appContract.identifierAppVendor =
                $configService.getUser().type == "VENDOR_AGENT" ?
                  FactoryObj.selectedAppCustomerUser.insertUser :
                  $configService.getUser().identifier;
            }
          }
          $contractService
            .getAllContracts(self.filterAllContracts)
            .then(function (response) {
              self.getListAppContractWorks = false;
              var contractList = response && response.appContractList;
              console.log("contractList: ", contractList);
              var totalCount = response && response.appContractListCount;
              console.log("contractList totalCount: ", totalCount);
              self.filterAllContracts.appContract.totalPages = getSTotalPages(
                totalCount
              );
              console.log(
                "filterAllContracts.appContract.totalPages: ",
                self.filterAllContracts.appContract.totalPages
              );
              self.searchUserObj.contractList = [];
              self.searchUserObj.contractList = addEmptyRow(contractList);
              console.log(
                "contractList LENGTH: ",
                self.searchUserObj.contractList.length
              );
            });
        }
      };

      //To retrieve all the total contracts
      var getListAppTotalContract = function () {
        //called by broadcast

        self.filterAllContracts.appContract.identifierAppCustomer = null;
        self.filterAllContracts.appContract.identifierAppVendor = $configService.getUser().identifier;

        $contractService
          .getAllTotalContracts(self.filterAllContracts)
          .then(function (response) {
            self.getListAppContractWorks = false;
            var contractList = response && response.allAppContractList;
            console.log("contractList: ", contractList);
            var totalCount = response && response.allAppContractListCount;
            console.log("contractList totalCount: ", totalCount);
            self.filterAllContracts.appContract.totalPages = getSTotalPages(
              totalCount
            );
            console.log(
              "filterAllContracts.appContract.totalPages: ",
              self.filterAllContracts.appContract.totalPages
            );

            $scope.searchUserObj = [];
            $scope.searchUserObj.contractList = [];
            $scope.searchUserObj.contractList = addEmptyRow(contractList);
            console.log(
              "contractList LENGTH: ",
              $scope.searchUserObj.contractList.length
            );
          });
      };

      //update table getAllSimulations
      self.updateOrderTableSimulation = function (ordColName, ordType) {
        self.filterAllContracts.appContract.orderColumnName = ordColName;
        self.filterAllContracts.appContract.orderType = ordType;
        getListAppContract();
      };

      self.pageSIndexIndietro = function (value) {
        if (value == "init") {
          self.filterAllContracts.appContract.pageIndex = 1;
        } else {
          if (self.filterAllContracts.appContract.pageIndex > 1) {
            self.filterAllContracts.appContract.pageIndex--;
          }
        }
        updateOffsetAndSearch();
      };

      self.pageSIndexAvanti = function (value) {
        if (value == "end") {
          //subito pagina finale
          self.filterAllContracts.appContract.pageIndex =
            self.filterAllContracts.appContract.totalPages;
        } else {
          //avanzo +1
          if (
            self.filterAllContracts.appContract.pageIndex <
            self.filterAllContracts.appContract.totalPages
          ) {
            self.filterAllContracts.appContract.pageIndex++;
          }
        }
        updateOffsetAndSearch();
      };

      self.checkNotNull = function (codeValue, objStringToCheck) {
        if (objStringToCheck) {
          return $filter("translate")(codeValue);
        }
        return null;
      };

      /** Extract information from metadata and return a string with a list of product infos **/
      self.prepareGoodTypeBrandConcat = function (metadata) {
        if (metadata) {
          // consider only not empty row!
          var metadataObj = metadata;
          var finalConcatString = "";
          if (
            metadataObj.leasingObj != null &&
            metadataObj.leasingObj.leasingItems != null &&
            metadataObj.leasingObj.leasingItems.length > 0
          ) {
            for (
              var index = 0; index < metadataObj.leasingObj.leasingItems.length; index++
            ) {
              var prodItem = metadataObj.leasingObj.leasingItems[index];
              var separator = ", ";
              if (finalConcatString.length == 0) {
                separator = "";
              }
              finalConcatString +=
                separator + prodItem.brand + " " + prodItem.goodType;
            }
          }
          return finalConcatString;
        }
      };

      function updateOffsetAndSearch() {
        self.filterAllContracts.appContract.offset =
          (self.filterAllContracts.appContract.pageIndex - 1) *
          self.filterAllContracts.appContract.limit;
        getListAppContract();
      }

      function getSTotalPages(totalCount) {
        //se il resto Ã¨ zero non va aggiunto +1
        var addPlusOneToTotal = 0;
        var totModuloResult =
          totalCount % Number(self.filterAllContracts.appContract.limit);
        if (totModuloResult > 0) {
          addPlusOneToTotal = 1;
        }
        return (
          Math.floor(
            totalCount / Number(self.filterAllContracts.appContract.limit)
          ) + addPlusOneToTotal
        );
      }

      function addEmptyRow(restList) {
        var outputList = [];
        var indexRestList = Number(self.filterAllContracts.appContract.limit);
        if (restList != null) {
          outputList = restList;
          indexRestList =
            Number(self.filterAllContracts.appContract.limit) - restList.length;
        }

        if (indexRestList > 0) {
          for (var irl = 0; irl < indexRestList; irl++) {
            outputList.push({});
          }
        }
        return outputList;
      }

      // PAGINATION END

      self.getFromDomain = function (value, list, delay, cb) {
        $timeout(function () {
          HttpService.send(
            "/uni/typedomain/getDomainSet", {
            table: "RI_DROPDOWN_DOMAINS",
            column: value
          },
            false
          ).then(function (response) {
            self.dropdown[list] = response.domainList;

            if (cb) {
              cb();
            }
          });
        }, delay);
      };
      self.dropdown = {};
      self.getFromDomain("DOCUMENT_TYPE", "tipiDocumento", 0);

      self.viewDocument = function (signer) {
        $modalService.openModal("documentoRiconoscimentoFirmatario");
        self.documentData = signer.documento;
        //			self.documentData.tipo = self.dropdown.tipiDocumento.find(function(el){
        //				return el.value.toUpperCase() === self.documentData.tipo.toUpperCase();
        //			}).name;
        /// check
        if (!self.documentData.name) {
          self.documentData.name = self.dropdown.tipiDocumento.find(function (
            el
          ) {
            return (
              el.value.toUpperCase() === self.documentData.tipo.toUpperCase()
            );
          }).name;
        }
        self.documentData.tipo = self.dropdown.tipiDocumento.find(function (el) {
          return (
            el.value.toUpperCase() === self.documentData.tipo.toUpperCase()
          );
        }).value;
      };

      self.checkDigitalSignature = function (signer) {
        signer.checkedDigitalSignature = !signer.checkedDigitalSignature;
      };

      self.printContract = function (contract) {
        self.updateSignatureMethod(
          propMap["CONTRACT_STATUS_CHOSEN_MANUAL_SIGNATURE_PRINTED"],
          contract
        );
        self.contractPrinted = true;
      };

      self.updateSignatureMethod = function (newStatus, contract) {
        $contractService
          .updateContractStatus(newStatus, contract)
          .then(function (updateOk) {
            if (updateOk) {
              //reload contracts
              getListAppContract();
            }
          });
      };

      self.updateContractMetadata = function (contract) {
        if (self.allSignerSelected(contract)) {
          self.updateSignatureMethod(
            propMap["CONTRACT_STATUS_CHOSEN_DIGITAL_SIGNATURE_CHECKED"],
            contract
          );
        }
        $contractService
          .updateContractMetadata(contract)
          .then(function (updateOk) {
            if (updateOk) {
              //reload contracts
              getListAppContract();
              closeModal();
            }
          });
      };

      /** returns true if all selected signers have have been checked **/
      self.allSignerSelected = function (contract) {
        var notCheckedSigners =
          contract &&
          contract.metadataContract.listaPf
            .filter(function (pf) {
              return pf.firmatario.selected;
            })
            .filter(function (selectedSigner) {
              return !selectedSigner.checkedDigitalSignature;
            });

        if (notCheckedSigners && notCheckedSigners.length === 0) {
          return true;
        }
        return false;
      };

      /** returns true if has been selected at least 1 signer **/
      self.atLeastOneSignerSelected = function () {
        var checkedSigners =
          self.selectedContract &&
          self.selectedContract.metadataContract.listaPf
            .filter(function (pf) {
              return pf.firmatario.selected;
            })
            .filter(function (selectedSigner) {
              return selectedSigner.checkedDigitalSignature;
            });

        if (checkedSigners && checkedSigners.length >= 1) {
          return false;
        }
        return true;
      };

      var addUsers = function () {
        self.closeConfirmModal();

        $contractService
          .addUsers(self.selectedContract)
          .then(function (updateOk) {
            if (updateOk) {
              console.log("returned!");
              getListAppContract();
            }
          });
      };

      self.confirmSigners = function () {
        addUsers();
        self.closeConfirmModal();
        self.updateSignatureMethod(
          propMap["CONTRACT_STATUS_WAITING_FOR_SIGNATURE"],
          self.selectedContract
        );
      };
      self.goToRealConfirm = function () {
        self.swConfirm = true;
      };

      self.openModal = function (contract) {
        self.swConfirm = false;
        self.selectedContract = contract;
        $("#signers-inner-contract-table-modal").modal("show");
      };

      self.openConfirmModal = function (contract) {
        self.selectedContract = contract;
        $("#signers-inner-contract-table-modal-confirm").modal("show");
      };

      self.goToUploadAdditionalDocs = function (contract) {
        $rootScope.goTo(
          "/uploadAdditionalDocs/" +
          contract.idContract +
          "/" +
          contract.idSimulation +
          "/" +
          contract.metadataContract.numPreventivo
        );
      };

      self.regenerateRi = function (contract) {
        console.log("contract: ", contract);
        $contractService
          .regenerateContract(contract.idContract)
          .then(function (response) {
            if (response.success && response.contractRegenerationOk) {
              $simulationService
                .getSimulationById({
                  appSimulation: {
                    id: contract.idSimulation
                  }
                })
                .then(function (getSimulationResponse) {
                  if (
                    getSimulationResponse.success &&
                    getSimulationResponse.appSimulation
                  ) {
                    FactoryObj.simulationItem =
                      getSimulationResponse.appSimulation;
                    $rootScope.$broadcast("goToRiViews", {});
                  }
                });
            }
          });
      };

      var closeModal = function () {
        $("#signers-inner-contract-table-modal").modal("hide");
        $("body").removeClass("modal-open");
        $(".modal-backdrop").remove();
      };

      self.closeConfirmModal = function () {
        $("#signers-inner-contract-table-modal-confirm").modal("hide");
        $("body").removeClass("modal-open");
        $(".modal-backdrop").remove();
      };

      /************************************************************
       *  UPLOADER
       ************************************************************/
      self.uploadDataFunc = function (contract) {
        self.uploadData = contract.idSimulation;
        self.contract = contract;
      };

      self.uploader = new FileUploader({
        url: "",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
          "App-Name": $rootScope.portalName
        }
      });
      self.finalUpload = function (uploadData) {
        var url;
        url =
          $configService.getAppConfig().url +
          "/simulator/upload/service-infos/" +
          encodeURIComponent(uploadData) +
          "/MANUAL-SIGNATURE/";

        for (var int = 0; int < self.uploader.queue.length; int++) {
          self.uploader.queue[int].url = url;
        }
        self.uploading = true;
        self.uploader.uploadAll();
      };

      self.generateDownloadLink = function (filename, directory) {
        return (
          $configService.getAppConfig().url +
          "/simulator/download/service-infos/" +
          encodeURIComponent(FactoryObj.simulationItem.id) +
          "/" +
          encodeURIComponent(directory) +
          "/" +
          encodeURIComponent(filename) +
          "/?token=" +
          $configService.getAppConfig().token
        );
      };
      self.uploader.onWhenAddingFileFailed = function (
        item /*{File|FileLikeObject}*/,
        filter,
        options
      ) {
        console.info("onWhenAddingFileFailed", item, filter, options);
      };

      self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        var fileName = fileItem.file.name;
        if (
          fileName.toLowerCase().indexOf(".pdf") > -1 ||
          fileName.toLowerCase().indexOf(".png") > -1 ||
          fileName.toLowerCase().indexOf(".jpg") > -1 ||
          fileName.toLowerCase().indexOf(".jpeg") > -1 ||
          fileName.toLowerCase().indexOf(".p7m") > -1
        ) {
          self.uploader.queue[0].progress = 0;
        } else {
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
          $rootScope.$broadcast("addAlert", {
            text: "FORMAT_NOT_SUPPORTED"
          });
        }
      };

      self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
      };

      self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
      };

      self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
      };

      self.uploader.onProgressAll = function (progress) { };

      self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        self.uploading = false;
      };

      self.uploader.onErrorItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onErrorItem", fileItem, response, status, headers);
        $rootScope.$broadcast("addAlert", {
          text: "ERROR_UPLOADING_FILE"
        });
      };

      self.uploader.onCancelItem = function (
        fileItem,
        response,
        status,
        headers
      ) { };

      self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (response.success) {
          //alert("ok!");
          console.log(fileItem);
          $rootScope.$broadcast("addAlert", {
            text: "UPLOAD_SUCCESS"
          });

          /*
          var contract = self.searchUserObj.contractList.find(function(el){
            return el.simulationId = self.simulationId;
          });
          if(!contract.files)	contract.files = [];
          contract.files.push({"nameFile": response.fileName })*/
        }

        self.uploader.queue = [];
      };

      self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
        self.updateSignatureMethod(
          propMap["CONTRACT_STATUS_SIGNED"],
          self.contract
        );
      };

      self.generateDownloadLink = function (item) {
        var url = "/simulator/contract/downloadZip/service-infos/" +
          encodeURIComponent("NUMEROCONTRATTO") +
          "/" +
          encodeURIComponent("MODULO") +
          "/"


        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      /**
       * Called download detail document contract
       */

      self.downloadPdfDetailContract = function (idContract) {
        console.log("clicked");
        var url = "/simulator/printContractDetails/service-infos/" +
          encodeURIComponent(idContract) +
          "/" +
          "CONTRACT" +
          "/"


        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };
    }
  });